import { useContext } from "react";
import { RiExchangeCnyLine } from "react-icons/ri";
import { ProductCostContext } from "./products/Detail";

const ComponentTitle = ({ product }) => {
  const { defaultCurrency } = useContext(ProductCostContext);
  const priceCurrencies = product.prices.map((i) => i.currency);
  // if it contains not defaultCurrency, then shows the icon
  const containsNotDefaultCurrency =
    priceCurrencies.filter((i) => i !== defaultCurrency).length > 0;

  return (
    <div className="flex items-center">
      {containsNotDefaultCurrency ? (
        <RiExchangeCnyLine
          className="mr-2 text-teal-600 flex-shrink-0"
          size={18}
        />
      ) : null}

      <div>
        [{product.number}] {product.name}
      </div>
    </div>
  );
};

export default ComponentTitle;
